import { useCallback, useEffect, useState } from "react"
import { RECAPTCHA_V3_SITE_KEY } from "@/constants/allconstants";

export const ReCaptchaV3 = () => {
    const [isRecapchaLoaded, setIsRecapchaLoaded] = useState(false);
    useEffect(() => {
        if (window.grecaptcha) {
            setIsRecapchaLoaded(true);
        }else{
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_V3_SITE_KEY}`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
            script.onload = () => {
                setIsRecapchaLoaded(true);
            }
        }
    }, [])
    const executeRecaptcha = useCallback(async (action) => {
        if(isRecapchaLoaded && window.grecaptcha){
            return await window.grecaptcha.execute(RECAPTCHA_V3_SITE_KEY, {action});
        }
    }, [isRecapchaLoaded]);
    return executeRecaptcha;
}